module.exports = __webpack_public_path__ + "media/credit/cirrus-a58823c1.png";